import {IBulletinBoardState, initialBulletinBoardState} from '@app/core/store/state/bulletin-board.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {BulletinBoardActions, EBulletinBoardActions} from '@app/core/store/actions/bulletin-board.actions';
import {getUniqueListBy} from '@app/core/helpers';

export const bulletinBoardReducers = (
	state = initialBulletinBoardState,
	action: BulletinBoardActions | ErrorActions,
): IBulletinBoardState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
			};
		}
		case EBulletinBoardActions.GetBulletinPosts: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EBulletinBoardActions.GetBulletinPostsSuccess: {
			const posts = [...state.bulletinPosts, ...action.bulletinPosts];

			return {
				...state,
				bulletinPosts: posts.map(bp => {
					if (bp.latest_message_board_post_comment?.id) {
						bp.comments[0] = bp.latest_message_board_post_comment;
					}

					return bp;
				}),
				isLoading: false,
				pagination: action.pagination,
			};
		}
		case EBulletinBoardActions.GetBulletinPostSuccess: {
			return {
				...state,
				postToEdit: action.bulletinPost,
				isLoading: false,
			};
		}
		case EBulletinBoardActions.PostBulletinPostSuccess: {
			return {
				...state,
				bulletinPosts: [action.post, ...state.bulletinPosts],
				postToEdit: null,
				isLoading: false,
			};
		}
		case EBulletinBoardActions.CreateBulletinBoardCommentSuccess: {
			return {
				...state,
				bulletinPosts: state.bulletinPosts.map(post => {
					if (post.id === action.boardPost.id) {
						post.message_board_post_comments_count += 1;
						post.comments.unshift(action.comment);
					}

					return post;
				}),
				isLoading: false,
			};
		}
		case EBulletinBoardActions.GetBulletinPostCommentsSuccess: {
			return {
				...state,
				bulletinPosts: state.bulletinPosts.map(post => {

					if (post.id === action.postId) {
						post.comments = getUniqueListBy([...post.comments, ...action.comments], 'id');
					}

					return post;
				}),
				commentsPagination: action.pagination,
				isLoading: false,
			};
		}
		case EBulletinBoardActions.PatchBulletinPostSuccess: {
			return {
				...state,
				bulletinPosts: state.bulletinPosts.map(p => p.id === action.post.id ? action.post : p),
				postToEdit: null,
				isLoading: false,
			};
		}

		case EBulletinBoardActions.ClearEditPostComponent: {
			return {
				...state,
				postToEdit: undefined,
				isLoading: false,
			};
		}
		case EBulletinBoardActions.DeleteBulletinPostSuccess: {
			return {
				...state,
				bulletinPosts: state.bulletinPosts.filter(posts => posts.id !== action.postId),
			};
		}
		case EBulletinBoardActions.GetGroupsForBulletinPostsSuccess: {
			return {
				...state,
				groups: action.groups,
				isLoading: false,
			};
		}
		case EBulletinBoardActions.SetSelectedPostForComments: {
			return {
				...state,
				selectedPostIdForComments: action.postId,
			};
		}
		case EBulletinBoardActions.PatchBulletinBoardCommentSuccess: {
			return {
				...state,
				bulletinPosts: state.bulletinPosts.map(post => {
					if (post.id === action.postId) {
						post.comments = post.comments.map(comment => {
							if (comment.id === action.commentId) {
								comment.comment = action.comment.comment;
							}

							return comment;
						});
					}

					return post;
				}),
			};
		}

		case EBulletinBoardActions.LikePostSuccess: {
			return {
				...state,
				bulletinPosts: state.bulletinPosts.map(post => {
					if (post.id === action.bulletinBoardPost.id) {
						post.message_board_post_likes_count += 1;
						post.liked = true;
						if (!post.overlappingLikeIcons) {
							post.overlappingLikeIcons = [];
						}
						post.latest_four_message_board_post_likes.unshift(action.like);
						const icon = {imageUrl: undefined, initials: action.like.user.getInitials()};
						if (action.like.user.profile_picture && action.like.user.profile_picture.download_url) {
							icon['imageUrl'] = action.like.user.profile_picture.download_url;
						}
						post.overlappingLikeIcons.unshift(icon);
						if (post.latest_four_message_board_post_likes.length > 4) {
							post.overlappingLikeIcons.splice(post.overlappingLikeIcons.length - 1, 1);
						}
					}

					return post;
				}),
			};
		}
		case EBulletinBoardActions.DislikePostSuccess: {
			return {
				...state,
				bulletinPosts: state.bulletinPosts.map(post => {
					if (post.id === action.bulletinBoardPost.id) {
						post.message_board_post_likes_count -= 1;
						post.liked = false;

						const index = post.latest_four_message_board_post_likes.findIndex(like => like.id === action.like.id);
						if (post.overlappingLikeIcons[index]) {
							post.overlappingLikeIcons.splice(index, 1);
						}
						post.latest_four_message_board_post_likes.splice(index, 1);
						const icon = {imageUrl: undefined, initials: action.like.user.getInitials()};
						if (post.latest_four_message_board_post_likes.length === 4) {
							const pushIcon = post.latest_four_message_board_post_likes[3];
							if (action.like.user.profile_picture && action.like.user.profile_picture.download_url) {
								icon['imageUrl'] = action.like.user.profile_picture.download_url;
							}
							post.overlappingLikeIcons.unshift(icon);
						}
					}

					return post;
				}),
			};
		}

		case EBulletinBoardActions.GetPostLikedByInfo: {
			return {
				...state,
				isLoadingInfo: true,
			};
		}
		case EBulletinBoardActions.GetPostLikedByInfoSuccess: {
			return {
				...state,
				isLoadingInfo: false,
				postLikedByInfo: [...state.postLikedByInfo, ...action.likes],
				postLikedByInfoPagination: action.pagination,
			};
		}
		case EBulletinBoardActions.GetPostSeenByInfo: {
			return {
				...state,
				isLoadingInfo: true,
			};
		}
		case EBulletinBoardActions.GetPostSeenByInfoSuccess: {
			return {
				...state,
				isLoadingInfo: false,
				postSeenByInfo: action.users,
			};
		}

		case EBulletinBoardActions.DeleteBulletinBoardCommentSuccess: {
			return {
				...state,
				bulletinPosts: state.bulletinPosts.map(post => {
					if (post.id === action.postId) {
						post.message_board_post_comments_count -= 1;
						post.comments = [...post.comments.filter(c => c.id !== action.comment.id)];
						if (post.latest_message_board_post_comment && action.comment.id === post.latest_message_board_post_comment.id) {
							post.latest_message_board_post_comment = undefined;
						}
					}

					return post;
				}),
			};
		}

		case EBulletinBoardActions.GetPunchBulletinBoardPosts: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EBulletinBoardActions.ClearLikes: {
			return {
				...state,
				postLikedByInfo: [],
				postLikedByInfoPagination: undefined,
			};
		}
		case EBulletinBoardActions.ClearBulletinPosts: {
			return initialBulletinBoardState;
		}
		default:
			return state;
	}
};
